import { motion } from "framer-motion";
import { ShieldCheck, Users, Handshake } from "lucide-react";

const VISION_PILLARS = [
  {
    icon: ShieldCheck,
    title: "One Connected Ecosystem",
    text: "Unifying assessments, career guidance, higher-education admissions, and expert tutoring into one collaborative student journey.",
  },
  {
    icon: Users,
    title: "Technology + Human Expertise",
    text: "Combining technology for accessible discovery with the indispensable guidance of experienced counsellors, educators, and industry professionals.",
  },
  {
    icon: Handshake,
    title: "Student-Centric Approach",
    text: "Beginning with the student's unique interests, abilities, and aspirations rather than a product to empower confident, long-term decisions.",
  },
];

function PillarCard({ pillar, index }) {
  const Icon = pillar.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1, duration: 0.5 }}
      className="rounded-[2rem] border border-white/10 bg-white/5 p-6 backdrop-blur"
    >
      <Icon className="mb-4 text-[#C89B3C]" size={28} />
      <h3 className="mb-2 text-xl font-semibold">{pillar.title}</h3>
      <p className="leading-7 text-white/70">{pillar.text}</p>
    </motion.div>
  );
}

export default function VisionSection() {
  return (
    <section
      id="vision"
      className="relative overflow-hidden bg-[#063B30] px-6 py-12 text-white md:py-16"
    >
      <div className="pointer-events-none absolute inset-0 opacity-20">
        <img
          src="https://images.unsplash.com/photo-1524069290683-0457abfe42c3?auto=format&fit=crop&w=1800&q=70"
          alt=""
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#063B30] via-[#063B30]/80 to-[#063B30]/40" />
      </div>
      <div className="relative mx-auto max-w-7xl">
        <div className="grid gap-8 md:grid-cols-2 md:items-center">
          <div>
            <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#C89B3C]">
              Our Vision
            </p>
            <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl md:text-5xl">
              A more connected and intelligent education ecosystem.
            </h2>
          </div>
          <p className="text-base leading-7 text-white/75 md:text-lg">
            Crescet aims to reduce confusion in the student journey by bringing trusted guidance,
            scientific assessments, expert support, and education opportunities into one ecosystem.
            One ecosystem. Multiple student needs. Human expertise powered by technology.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {VISION_PILLARS.map((p, i) => (
            <PillarCard key={p.title} pillar={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
